import styled, { ThemeContext } from 'styled-components';
import { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import H3 from '@base/H3/H3';
import H6 from '@base/H6/H6';
import socialShare from '@utils/socialShare';
import {
  Spacings,
  PRIMARY_BORDER_WIDTH,
  SOLID_BORDER_STYLE,
  BorderColors,
  TextColors,
  mobile,
  BgColors
} from '@styles/index';
import Facebook from '@icon/Facebook';
import Twitter from '@icon/Twitter';

const Wrapper = styled.div`
  padding: ${Spacings.SPACING_10B} ${Spacings.SPACING_12B};
  text-align: center;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    padding: ${Spacings.SPACING_4B};
  }
`;

const ShareLink = styled.div`
  display: grid;
  grid-template: 1fr / 1fr max-content;
  grid-column-gap: ${Spacings.SPACING_4B};
  width: 464px;
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B};
  border-radius: ${Spacings.SPACING_2B};
  border: ${PRIMARY_BORDER_WIDTH} ${SOLID_BORDER_STYLE} ${BorderColors.BLUE};
  @media only screen and (max-width: ${mobile.maxWidth}) {
    width: 100%;
    padding: ${Spacings.SPACING_4B};
  }
`;

const Copy = styled(H6)`
  cursor: pointer;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    font-size: 12px;
  }
`;

const Flex = styled.div`
  display: flex;
  margin: ${Spacings.SPACING_6B} auto;
  justify-content: center;
`;

const Link = styled(H6)`
  color: ${({ theme }) => theme.colors.fontGrey};
  @media only screen and (max-width: ${mobile.maxWidth}) {
    font-size: 12px;
    white-space: nowrap;
  }
`;

const FB = styled(Facebook)`
  margin-right: ${Spacings.SPACING_3B};
  border-radius: ${Spacings.SPACING_2B};
  background-color: ${BgColors.DISABLED};
  cursor: pointer;
`;

const Tweet = styled(Twitter)`
  margin-right: ${Spacings.SPACING_3B};
  border-radius: ${Spacings.SPACING_2B};
  background-color: ${BgColors.DISABLED};
  cursor: pointer;
`;

const ShareDialog = ({ data, useDataLink, twitterText }) => {
  const theme = useContext(ThemeContext);
  const [copied, setCopied] = useState(false);
  const { name = '' } = data || {};
  const link = useDataLink ? data.permalink : window.location.href;
  const handleFBShare = () =>
    socialShare.shareToFB({
      url: link,
      title: name
    });
  const hadleTwitterShare = () =>
    socialShare.shareToTwitter({
      url: link,
      text: twitterText
    });

  const copyToClipboard = () =>
    navigator.clipboard.writeText(link).then(() => setCopied(true));

  return (
    <Wrapper>
      <H3 color={theme.colors.fontGrey}>Share via</H3>
      <Flex>
        <FB size="40px" onClick={handleFBShare} />
        <Tweet size="40px" onClick={hadleTwitterShare} />
      </Flex>
      <ShareLink>
        <Link lineClamp={1}>{link}</Link>
        <Copy
          color={copied ? TextColors.BLACK : TextColors.GREEN}
          onClick={copyToClipboard}
        >
          {copied ? 'Copied' : 'COPY'}
        </Copy>
      </ShareLink>
    </Wrapper>
  );
};

export default ShareDialog;

ShareDialog.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  useDataLink: PropTypes.bool,
  twitterText: PropTypes.string
};

ShareDialog.defaultProps = {
  data: {},
  useDataLink: false,
  twitterText: null
};
